import { useCallback } from "react";
import { useMutation, useQueryClient } from "react-query";
import { Api } from "src/apis/helpers/configs/api";
import { ProjectsService } from "src/apis/services/projects/projectsService";
import { ProjectsDto } from "src/data/models/projectsDtos/projectsDto.interface";
import { container } from "tsyringe";

export const useAddProjects = () => {
    const projectsService = container.resolve(ProjectsService);
    const queryClient = useQueryClient();

    const toggleAddProjects = useCallback(
        (data, variables, context) => {
            let lastData = queryClient.getQueryData<Array<ProjectsDto>>([Api.Projects.getProjects]);
            const finalData = [...lastData] ;
            finalData.push(data);
            lastData = finalData ;
            queryClient.setQueryData([Api.Projects.getProjects],lastData )
        },
        [],
    );
    return useMutation({
        mutationFn: (data: ProjectsDto) => {
            return projectsService.addProjects(data);
        },
        onSuccess: toggleAddProjects
    })

}
